import React from "react";

interface ProgressCircleProps {
  percentage: number;
  size?: number;
  strokeWidth?: number;
  label?: string;
  className?: string;
}

const ProgressCircle: React.FC<ProgressCircleProps> = ({
  percentage,
  size = 8,
  strokeWidth = 2,
  label,
  className = "",
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = `${(percentage / 100) * circumference} ${circumference}`;

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`w-${size / 4} h-${size / 4}`}
        style={{ width: size, height: size }}
      >
        <svg
          className="transform -rotate-90"
          viewBox={`0 0 ${size} ${size}`}
          style={{ width: size, height: size }}
        >
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="rgba(255, 255, 255, 0.2)"
            strokeWidth={strokeWidth}
            fill="none"
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="white"
            strokeWidth={strokeWidth}
            fill="none"
            strokeDasharray={strokeDasharray}
            strokeLinecap="round"
          />
        </svg>
      </div>
      {label && (
        <div className="ml-3 flex items-center gap-2">
          <span className="text-white text-lg font-medium">{percentage}%</span>
          <span className="text-white/80">{label}</span>
        </div>
      )}
    </div>
  );
};

ProgressCircle.defaultProps = {
  size: 8,
  strokeWidth: 2,
  label: undefined,
  className: "",
};

export default ProgressCircle;
